import { createFileRoute } from '@tanstack/react-router'
import { EmptyState } from '@/shared/ui/empty-state'

export const Route = createFileRoute('/telephony/profiles/')({
  component: () => (
    <EmptyState
      icon="phone"
      title="Выбери профиль"
      description="Слева — каталог профилей операторов"
    />
  ),
})
